/* ============================================================
   VP LIMITED EDITIONS

   Two jobs, both the same ones vp-editors-picks.js and
   vp-best-sellers.js do, and done the same way:

     1. reveal-on-scroll for every .vp-reveal inside a VP Limited
        Editions section.

     2. measuring the fixed header, so the masthead starts flush
        beneath it.

   THE WIREFRAME'S THIRD JOB IS GONE. It measured the allocation
   strip on every sheet and fell the ticks back to a proportional
   bar below ~7px a tick. The strip has been taken off the page, and
   the measuring went with it rather than being carried across
   watching for an element that no longer renders.

   ON THE HEADER. .vp-header is position:fixed, so it takes no space
   in the flow. The category convention is a flat margin-top, but
   that is the header's height WITH its announcement bar and at
   rest, and the header is not a fixed height anyway — .vp-hd-bar
   carries 52px of top padding at rest and 12px once compact, over
   rows whose height depends on the rendered type. So it is
   measured rather than assumed, and the result is written to
   --le-header-h. The CSS literal (83px) is only for the moment
   before this runs, and for JS being off.
   ============================================================ */
(function () {
  'use strict';

  var REDUCED = window.matchMedia &&
                window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- reveal on scroll ------------------------------------ */
  function observeReveals(scope) {
    var targets = scope.querySelectorAll('.vp-reveal:not(.in)');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window) || REDUCED) {
      Array.prototype.forEach.call(targets, function (el) { el.classList.add('in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });

    Array.prototype.forEach.call(targets, function (el) { io.observe(el); });

    /* backstop, as the other vp-* sections carry: nothing stays
       invisible because an observer never fired */
    window.setTimeout(function () {
      Array.prototype.forEach.call(targets, function (el) { el.classList.add('in'); });
    }, 3800);
  }

  /* ---- header offset --------------------------------------- */
  function syncHeaderOffset() {
    var header  = document.querySelector('.vp-header');
    var section = document.querySelector('.vp-le .le-mast');
    if (!header || !section) return;

    /* Only correct at rest. The header is ~40px shorter once
       compact, so measuring mid-scroll would set a short margin and
       the masthead would jump the moment you moved.

       Tested on scroll position rather than on a class the header's
       own script applies, because that script runs on the same
       DOMContentLoaded as this one and whichever executed second
       would decide whether the guard passed. */
    if ((window.scrollY || window.pageYOffset || 0) > 60) return;

    var headerBottom = header.getBoundingClientRect().bottom;
    var heroTop      = section.getBoundingClientRect().top;
    var drift        = heroTop - headerBottom;      /* >0 gap, <0 overlap */

    if (Math.abs(drift) < 0.5) return;              /* already flush */

    var current   = parseFloat(window.getComputedStyle(section).marginTop) || 0;
    var corrected = Math.max(0, Math.round(current - drift));

    document.documentElement.style.setProperty('--le-header-h', corrected + 'px');
  }

  function watchHeader() {
    if (!document.querySelector('.vp-le')) return;   /* not this page */
    syncHeaderOffset();

    /* the wordmark is a webfont: the header's height changes when it
       swaps in, so measure again once fonts have settled */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncHeaderOffset).catch(function () {});
    }
    window.addEventListener('resize', syncHeaderOffset, { passive: true });

    /* Late passes. Layout is still settling at DOMContentLoaded —
       images above the fold, the header's own scripts, the webfont
       swap — and theme.liquid's own offset script hedges the same
       way. Cheap, and it converges: once the two edges are flush the
       function returns without touching anything. */
    window.addEventListener('load', syncHeaderOffset);
    window.setTimeout(syncHeaderOffset, 300);
    window.setTimeout(syncHeaderOffset, 1200);

    var header = document.querySelector('.vp-header');
    if (header && window.ResizeObserver) {
      new window.ResizeObserver(syncHeaderOffset).observe(header);
    }
  }

  function boot() {
    var scopes = document.querySelectorAll('.vp-le');
    if (!scopes.length) return;
    Array.prototype.forEach.call(scopes, observeReveals);
    watchHeader();
  }

  /* Re-run in the theme editor, where a section can be re-rendered
     on its own without a page load. */
  document.addEventListener('shopify:section:load', function (e) {
    var scope = e.target.querySelector('.vp-le');
    if (scope) { observeReveals(scope); syncHeaderOffset(); }
  });

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
